import { createContext } from "react";
import useStagesByProjectId from "../../hooks/data/useStagesByProjectId";

export interface IStagesContext extends ReturnType<typeof useStagesByProjectId> {
}

export const StagesContext = createContext<IStagesContext>({
    data: undefined,
    total: undefined,
    idMap: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default StagesContext;